/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { Materiality } from '../types/initiative';

export const MaterialityTitle = {
  [Materiality.Low]: 'Low Materiality',
  [Materiality.Medium]: 'Medium Materiality',
  [Materiality.High]: 'High Materiality',
  [Materiality.None]: 'No Materiality',
}
